import { ITealiumEvent } from '@4tn/core-audio-player-shared';

export const trackLink = (eventData: ITealiumEvent) => {
  const utag = (window as any).utag || {};
  utag?.link?.(eventData);
};
